export default {
  computed: {
    selectedProperty() {
      return this.$store.state.properties.selectedProperty || {};
    },
    eligibilityCheck() {
      return this.$store.state.properties.eligibilityCheckDetails;
    },
    foundLicenseData() {
      return this.$store.state.properties.foundLicenseData || false;
    },
    proprietorAddress() {
      if (this.eligibilityCheck.proprietorStreetAddress1 === null) {
        return '';
      }
      let streetAddress = String(this.eligibilityCheck.proprietorStreetAddress1).trim();
      if (this.eligibilityCheck.proprietorStreetAddress2) {
        streetAddress = `${streetAddress} ${this.eligibilityCheck.proprietorStreetAddress2}`;
      }
      return String(`${streetAddress},
        ${this.eligibilityCheck.proprietorCity},
        ${this.eligibilityCheck.proprietorState},
        ${this.eligibilityCheck.proprietorCountry},
        ${this.eligibilityCheck.proprietorZip}`).replace(/\s+(?= )/g,'');
    },
  },
};